import LanguageIcon from "@mui/icons-material/Language";
import {Box, IconButton, Menu, MenuItem} from "@mui/material";
import {useState} from "react";

const Language = ({ language, changeLanguage }) => {

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleChangeLanguage = (value) => {
        changeLanguage(value)
        handleClose()
    }

    return (
        <Box>
            <IconButton  id="basic-button"
                         aria-controls={open ? 'basic-menu' : undefined}
                         aria-haspopup="true"
                         aria-expanded={open ? 'true' : undefined}
                         onClick={handleClick}>
                <LanguageIcon/>
            </IconButton>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {
                    [
                        {
                            title: 'Русский',
                            value: 'ru'
                        },
                        {
                            title: 'Қазақ',
                            value: 'kz'
                        },
                        {
                            title: 'English',
                            value: 'en'
                        }
                    ].map(x => <MenuItem onClick={() => handleChangeLanguage(x.value)}><Box sx={{ fontWeight: language === x.value ? 'bold' : 'regular' }}>{x.title}</Box></MenuItem>)
                }
            </Menu>
        </Box>
    )
}

export default Language;